import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardActionArea,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  const [value, setValue] = useState(product.rating);
  return (
    <Card className="card">
      <CardActionArea>
        <CardMedia
          component="img"
          height="250"
          image={product.image}
          alt={product.name}
        />
        <CardContent>
          <Typography gutterBottom variant="body2" component="div">

          <Typography>{product.name}</Typography>

          <Typography>${product.cost}</Typography>
          <Rating
            name='read-only'
            readOnly
            value={product.rating}
            percision={0.5}
          />
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className="card-actions">
        <Button className="card-button"
          variant="contained"
          onClick={() => {
            handleAddToCart(product._id,1);
          }}
        >
          ADD TO CART
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
